import React from 'react';
import { useTranslation } from 'react-i18next';
import type { SidebarNavGroupProps } from '../types';
import { SidebarNavItem } from './SidebarNavItem';
import styles from '../Sidebar.module.css';

export const SidebarNavGroup: React.FC<SidebarNavGroupProps> = ({
  group,
  isExpanded,
  onToggle,
  onItemClick,
}) => {
  const { t } = useTranslation();
  const Icon = group.icon;

  // Debug logging for mobile visibility
  React.useEffect(() => {
    if (group.id === 'management') {
      console.log('[SidebarNavGroup] Management group items:', group.items.length, group.items.map(i => i.id));
      console.log('[SidebarNavGroup] isExpanded:', isExpanded);
    }
  }, [group, isExpanded]);

  return (
    <div className={styles.navGroup}>
      <button
        type="button"
        className={styles.navGroupHeader}
        onClick={onToggle}
        aria-expanded={isExpanded}
      >
        <Icon size={12} className={styles.navGroupIcon} />
        <span className={styles.navGroupLabel}>{group.labelKey ? t(group.labelKey) : group.label}</span>
        {/* Triangle indicator */}
        <svg
          className={`${styles.navGroupTriangle} ${isExpanded ? styles.navGroupTriangleExpanded : ''}`}
          width="5"
          height="5"
          viewBox="0 0 5 5"
          fill="currentColor"
        >
          <polygon points="0,0 5,2.5 0,5" />
        </svg>
      </button>
      <div
        className={`${styles.navGroupContent} ${isExpanded ? styles.navGroupContentOpen : ''}`}
      >
        {group.items.map((item) => (
          <SidebarNavItem
            key={item.id}
            item={item}
            onClick={onItemClick}
            indented
          />
        ))}
      </div>
    </div>
  );
};
